import { Country } from '../../models/Country';
import moment from 'moment';
export interface Client {
    id: string;
    address: string;
    appDisabled: string;
    birthDate: moment.Moment;
    burn: string;
    cardNumber: string;
    cityId: string;
    cityName: string;
    clinicName: string;
    completeName: string;
    completeNumber: number;
    colony: string;
    country: Country;
    currentClinic: string;
    customFields: CustomField[];
    date: string;
    deferred: boolean;
    delegation: string;
    documentType: string;
    email: string;
    enableGc: string;
    enableRGPD: string;
    extra: string;
    fwa: string;
    fwaLogin: string;
    fwaPassword: string;
    history: string;
    iessuf: string;
    incomplete: boolean;
    investigate: boolean;
    job: string;
    legalRepresentative: Partial<Client>;
    localIe: string;
    longNotes: string;
    mobileClassId: string;
    name: string;
    nif: string;
    notes: string;
    number: string;
    parenthood: string;
    phone: string;
    phone2: string;
    phone3: string;
    phonePrefix: string;
    phonePrefix2: string;
    phonePrefix3: string;
    postCode: string;
    profileImage: string;
    provinceId: string;
    referrer: string;
    referrerId: string;
    rg: string;
    sex: string;
    strNum: string;
    surname1: string;
    surname2: string;
    temporal: boolean;
    vouchers: string;
    vip: string;
}

export const getAge = (birthDate: moment.Moment, date: moment.Moment = moment()): number => date.diff(birthDate, 'y');

export enum CustomFieldTypes {
    TEXT = 'text',
    SELECT = 'select',
    CHECKBOX = 'checkbox'
}

export interface CustomField {
    enabled: boolean;
    label: string;
    id: number;
    options: string[];
    readonly: boolean;
    type: CustomFieldTypes;
    value: string;
}

export enum ClientDuplicityTypes {
    NAME = 'N',
    MAIL = 'M',
    DNI = 'D',
    CARD = 'C',
    PHONE_1 = 'P',
    PHONE_2 = 'S',
    PHONE_3 = 'T'
}

export const createClient = (params: any): Client => ({
    id: params.clientid,
    number: params.clientnumber,
    completeNumber: params.clientNumber,
    name: params.clientOnlyName,
    completeName: params.clientname,
    phone: params.clientPhone,
    clinicName: params.clinicName,
    incomplete: params.clientincomplete !== '0',
    deferred: params.clientdeferred !== '0',
    investigate: params.clientinvestigate !== '0',
    currentClinic: params.currentclinic,
    temporal: params.clientmp !== '0'
} as Client);

export const createDuplicateClient = (params: any): Client => ({
    id: params.clientid,
    name: params.clientname,
    email: params.clientemail,
    phone: params.clientphone,
} as Client);
